import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllCars, selectCars } from "../../../redux/car/car-slice";
import CardHorizontal from "../card-horizontal-row/card-horizontal";
import { IoChevronBackOutline } from "react-icons/io5";
import imgCar from "../../../assets/images/car7.png";
import { motion } from "framer-motion";

const AddService = () => {
  const dispatch = useDispatch();
  const cars = useSelector(selectCars);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getAllCars());
  }, [dispatch]);

  const closeHandler = () => {
    navigate(-1);
  };

  return (
    <div className="container py-3">
      <div className="card shadow-lg border-0 rounded-3 overflow-hidden">
        {/* Header */}
        <div className="card-header bg-primary text-white d-flex align-items-center justify-content-between">
          <motion.button
            type="button"
            className="btn btn-light btn-sm rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: "36px", height: "36px" }}
            onClick={closeHandler}
            aria-label="بازگشت"
            whileHover={{ scale: 1.15, rotate: -10 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 300, damping: 10 }}
          >
            <IoChevronBackOutline size={20} />
          </motion.button>

          <h5 className="mb-0 fw-bold text-center flex-grow-1">
            فهرست خودروها
          </h5>

          {/* فضای خالی برای وسط چین موندن عنوان */}
          <div style={{ width: "36px" }}></div>
        </div>

        {/* Body */}
        <div className="card-body p-3">
          {cars.length === 0 ? (
            <div className="alert alert-info text-center">
              خودرویی ثبت نشده است.
            </div>
          ) : (
            <div className="row g-3">
              {cars.map((res, index) => (
                <motion.div
                  key={res.id}
                  className="col-12 col-md-6 col-lg-4"
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                >
                  <CardHorizontal car={res} />
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddService;
